/**
* @file right pannel
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Form, {Item as FormItem} from 'antd/lib/form';
import {Button as RadioButton, Group} from 'antd/lib/radio';
import Tooltip from 'antd/lib/tooltip';
import Switch from 'antd/lib/switch';
import {PannelFieldsChanged, ResetStartFilter} from './actions';
import ColorLegend from './ColorLegend';
import StartPointFilter from './StartPointFilter';
import getCityInfo from './lib/getCityInfo'
import City from './City';

const jsdom = navigator.userAgent.includes('Node.js'); //snapshotting

const cityComponent = React.createFactory(City);
const colorLegend = React.createFactory(ColorLegend);
const startPointFilter = React.createFactory(StartPointFilter);
const div = React.createFactory('div');
const span = React.createFactory('span');
const a = React.createFactory('a');
const form = React.createFactory(Form);
const switchComponent = React.createFactory(Switch);
const formItem = React.createFactory(FormItem);
const radioGroup = React.createFactory(Group);
const radioButton = React.createFactory(RadioButton);
const tooltip = React.createFactory(Tooltip);

class Pannel extends Component {
  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      styleParamName, startFilter, onFilterResetClick, city, predictedWorkout
    } = this.props;
    const {descriptionShort} = getCityInfo(city) || {};
    const pannelItemStyle = {
      colon: false,
      className: 'Pannel__form-item'
    }
    return div(
      {
        className: 'Pannel'
      },
      form(
        {
          className: 'Pannel__form'
        },
        formItem(
          {...pannelItemStyle},
          div(
            {
              className: 'Pannel__first-line'
            },
            div(
              {},
              div(
                {
                  className: 'Pannel__title'
                },
                'Strava Activities'
              )
            ),
            div(
              {className: 'Pannel__city'},
              cityComponent()
            ),
          ),
          descriptionShort ? div(
            {className: 'Pannel__second-line'},
            descriptionShort
          ) : null,
          div(
            {className: 'Pannel__post'},
            a({
              className: 'Pannel__post-link',
              target: '_blank',
              title: 'Making alternative to Strava Heatmap',
              href: 'https://medium.com/@vovabilonenko/strava-activities-map-6cbce0380ec1'
            }, 'About This Map'),
            city === 'brussels' ? a({
              className: 'Pannel__post-link',
              target: '_blank',
              title: 'Discovering Brussels Cycling Scene Using Smart Strava Maps',
              href: 'https://sladkovm.github.io/cycling/2017/08/26/Discovering-Brussels-Cycling-Scene-Using-Smart-Strava-Maps.html'
            }, 'About Brussels Cycling Scene') : null
          )
        ),
        formItem(
          {label: 'Map Style', ...pannelItemStyle},
          getFieldDecorator('style')(
            radioGroup(
              {},
              radioButton({value: 'lines'}, 'Lines'),
              radioButton({value: 'points'}, 'Points')
            )
          )
        ),
        formItem(
          {
            label: 'Color by',
            ...pannelItemStyle,
            ...{className: 'Pannel__snapping-form-item'}
          },
          getFieldDecorator('styleParamName')(
            radioGroup(
              {},
              tooltip(
                {title: 'Ride average speed', placement: 'bottom'},
                radioButton({value: 'average_speed'}, 'Average Speed')
              ),
              tooltip(
                {title: 'Ride speed at current segment', placement: 'bottom'},
                radioButton({value: 'speed'}, 'Segment Speed')
              )
            )
          )
        ),
        city === 'brussels' ? div(
          {className: 'Pannel__snapping-form-item Pannel__switch'},
          getFieldDecorator('predictedWorkout')(
            switchComponent({
              checked: predictedWorkout
            })
          ),
          div(
            {className: 'Pannel__switch-label'},
            div({}, 'Show only workouts'),
            a({
              href: 'https://sladkovm.github.io/machine_learning/2017/08/07/Using-Machine-Learning-To-Separate-Workouts-From-Commutes.html',
              target: '_blank',
              title: 'Using Machine Learning to Separate Workouts from Commutes'
            }, 'read about AI behind it')
          )
        ) : null,
        div(
          {className: 'Pannel__snapping-form-item Pannel__switch'},
          getFieldDecorator('sequentialColorScale')(
            switchComponent()
          ),
          span(
            {className: 'Pannel__switch-label'},
            'Sequential color scale'
          )
        ),
        formItem(
          {
            label: `${({
              average_speed: 'Ride Average Speed',
              speed: 'Ride Segment Speed'
            })[styleParamName]} (KPH)`,
            ...pannelItemStyle
          },
          colorLegend()
        ),
        jsdom ? null : formItem(
          {
            ...pannelItemStyle
          },
          startPointFilter({startFilter, onFilterResetClick})
        ),
        div(
          {className: 'Pannel__copyright'},
          a({
            className: 'Pannel__strava-logo',
            href: 'http://labs.strava.com/developers/',
            target: '_blank'
          }),
          div(
            {className: 'Pannel__links'},
            a({
              href: 'https://twitter.com/delfrrr',
              target: '_blank'
            }, 'Twitter'),
            a({
              href: 'http://eepurl.com/cZpelb',
              target: '_blank'
            }, 'Leave feedback'),
          ),
        )
      )
    )
  }
}

export default connect(
  ({
    style,
    styleParamName,
    startFilter,
    city,
    predictedWorkout,
    sequentialColorScale
  }, props) => {
    return {
      style,
      styleParamName,
      startFilter,
      city,
      predictedWorkout,
      sequentialColorScale
    };
  },
  (dispatch) => {
    return {
      dispatch,
      onFilterResetClick() {
        dispatch(new ResetStartFilter());
      }
    };
  }
)(Form.create({
  mapPropsToFields({
    style,
    styleParamName,
    predictedWorkout,
    sequentialColorScale
  }) {
    return {
      style: {value: style},
      styleParamName: {value: styleParamName},
      predictedWorkout: {value: predictedWorkout},
      sequentialColorScale: {value: sequentialColorScale}
    };
  },
  onFieldsChange(props, fields) {
    const {dispatch} = props;
    dispatch(new PannelFieldsChanged(props, fields));
  }
})(Pannel));



// WEBPACK FOOTER //
// ./src/Pannel.js